module.exports = __webpack_public_path__ + "img/kechaung.485fb36d.jpg";